const { BaseClient } = require('../shared')

const handle404Error = e => {
    try {
        if (e.response.status.toString() === '404') {
            return []
        }
    } catch (e2) {
        console.log('ORIGINAL ERROR THROWING CATCH ERROR:', e)
        throw e2
    }
}

class MemberClient extends BaseClient {
    constructor(
      memberServiceUrl = process.env.MEMBER_DATA_URL,
      memberServiceSecretName = process.env.CENTIVO_MEMBER_SECRET_NAME || 'member-data-system-broker-service-key',
      axiosOptions
    ) {
      super(memberServiceUrl, memberServiceSecretName, axiosOptions)
    }

    async getMemberData(memberUuid) {
        await this.createSecureAxiosInstance()

        try {
          const response = await this.secureAxiosInstance.get(
            `getMemberData`,
            {
              params: {
                memberUuid
              }
            }
          )

          if (response.status !== 200) {
            return null
          }

          return response.data
        } 
        catch (e) {
          return handle404Error(e)
        }
    }
    
    async getMemberDataByCertificateNumber(certificateNumber) {
        await this.createSecureAxiosInstance()

        try {
          const response = await this.secureAxiosInstance.get(
            `getMemberDataByCertificateNumber`,
              {
                params: {
                    certificateNumber,
                }
              }
          )
            
          if (response.status !== 200) {
            return null
          }

          return response.data
        } 
        catch (e) {
          return handle404Error(e)
        }
    }
    
    async getMembersByPcpTin(tin, lastEvalKey) {
        await this.createSecureAxiosInstance()

        try {
          const response = await this.secureAxiosInstance.get(
            `getMembersByPcpTin`, 
            {
              params: {
                tin,
                lastEvalKey
              }
            }
          )
    
          if (response.status !== 200) {
            return null
          }
            
          return response.data
        } 
        catch (e) {
          return handle404Error(e)
        }
    }
    
    /**
     * @param {*} memberUuid
     * @returns
     */
     async getPcpTransactionsByMember(memberUuid) {
        await this.createSecureAxiosInstance()

        try {
          const response = await this.secureAxiosInstance.get(
            `getPcpTransactionsByMember`,
            {
              params: {
                memberUuid,
              }
            }
          )
            
            if (response.status !== 200) {
                return null
            }
            return response.data
        } 
        catch (e) {
            return handle404Error(e)
        }
    }
    
    /**
     * @param {*} tin
     * @param {*} options (currently supports enableCustomCompression as a header set to true for compression calls)
     * @returns
     */
    async getMembersAndPcpTransactionByPcpTin(tin, options = {}) {
        await this.createSecureAxiosInstance(options?.headers)

        try {
          const response = await this.secureAxiosInstance.get(
            `getMembersAndPcpTransactionByPcpTin`,
            {
              params: {
                tin,
                ...options?.params,
              }
            }
          )
          
          if (response.status !== 200) {
            return null
          }
            
          return response.data
        } 
        catch (e) {
            return handle404Error(e)
        }
    }
    
    /**
     * @param {{
     *  queryParams: {
     *    memberUuid: string
     *    pcpChosenBy: string
     *  }
     *  body: {
     *    carepoint: Record<string, any>
     *    meta: Record<string, any>
     *  }
     *  headers: Record<string, string>
     * }} params
     */
    async putPcpTransactionWithCarepoint({
        queryParams,
        body,
        headers,
    }) {
        await this.createSecureAxiosInstance(headers)

        try {
            const response = await this.secureAxiosInstance.put(
                `/putPcpTransactionWithCarepoint`,
                body,
                {
                  params: queryParams,
                }
            )

            if (response.status !== 200) {
                return { code: response.status, error: response.data }
            }

            return { code: response.status, data: response.data }
        } 
        catch (e) {
            return { code: 500, error: e }
        }
    }
}

module.exports = {
    MemberClient
}